export default function DSA_Quick_Sort() {
  return <div>DSA_Quick_Sort Component</div>;
}
